import React from "react";

import StarRatingInput from "./StarRatingInput";
import ownerStyles from "../../styles/components/product/ProductReviewOwnerFields.module.css";

const ProductReviewOwnerFields = ({ formConfig, values, onChange }) => {
  if (!formConfig) return null;

  const update = (patch) => onChange({ ...values, ...patch });
  const outcomes = formConfig.outcomes || [];

  return (
    <>
      {outcomes.length > 0 && (
        <fieldset className={ownerStyles.group}>
          <legend className={ownerStyles.legend}>
            How does it do on these? <span className={ownerStyles.optional}>(optional)</span>
          </legend>
          {outcomes.map((outcome) => (
            <div key={outcome.key} className={ownerStyles.outcomeRow}>
              <span className={ownerStyles.outcomeLabel}>{outcome.label}</span>
              <StarRatingInput
                size={20}
                rating={values.outcomeRatings?.[outcome.key] || 0}
                onChange={(star) =>
                  update({
                    outcomeRatings: { ...(values.outcomeRatings || {}), [outcome.key]: star },
                  })
                }
              />
            </div>
          ))}
        </fieldset>
      )}

      <div className={ownerStyles.grid}>
        <label className={ownerStyles.field}>
          <span>How long have you owned it?</span>
          <select
            value={values.ownershipDuration || ""}
            onChange={(e) => update({ ownershipDuration: e.target.value })}
          >
            <option value="">Prefer not to say</option>
            {(formConfig.ownershipDurations || []).map((d) => (
              <option key={d.key} value={d.key}>
                {d.label}
              </option>
            ))}
          </select>
        </label>
        <label className={ownerStyles.field}>
          <span>What do you mainly use it for?</span>
          <select
            value={values.mainUse || ""}
            onChange={(e) => update({ mainUse: e.target.value })}
          >
            <option value="">Choose one</option>
            {(formConfig.uses || []).map((use) => (
              <option key={use} value={use}>
                {use.charAt(0).toUpperCase() + use.slice(1)}
              </option>
            ))}
          </select>
        </label>
        <label className={ownerStyles.field}>
          <span>Exact version you own</span>
          <input
            type="text"
            maxLength={120}
            value={values.variant || ""}
            placeholder="e.g. 256GB, 65-inch, Snapdragon version"
            onChange={(e) => update({ variant: e.target.value })}
          />
        </label>
        <label className={ownerStyles.field}>
          <span>Compared with what you had before</span>
          <select
            value={values.comparedToPrior || ""}
            onChange={(e) => update({ comparedToPrior: e.target.value })}
          >
            <option value="">Choose one</option>
            {(formConfig.comparisonOptions || []).map((c) => (
              <option key={c.key} value={c.key}>
                {c.label}
              </option>
            ))}
          </select>
        </label>
      </div>
    </>
  );
};

export default ProductReviewOwnerFields;
